import { get } from 'lodash';

export const getFeedSEOTags = state => state.feedSEOTags;

export const getFeedSEOTitle = state => get(state, 'feedSEOTags.title', '');
export const getFeedSEOLinks = state => get(state, 'feedSEOTags.links', []);
export const getFeedSEOMetaTags = state => get(state, 'feedSEOTags.metaTags', []);
